module.exports = __webpack_public_path__ + "static/scale-model-of-public-art-\"endless-miles\"-in-inglewood-california-93d4313bfe390a5bbf895f04f3912499.png";